// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API/LoggingAPI';
import { onRequestError } from 'io/API/errorHandling';


const getLog = contextConfiguration => axios.get(
	'/log',
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getLog;
